export default __webpack_public_path__ + "static/dark-theme-img-292269bc1688d31369ec7e02f24abb5d.webp";